import { SPORT_CATEGORY } from './eventCategories';

export const createMemberRecordTabs = participantKey => [
  { key: 'organized', label: '我發起的' },
  { key: participantKey, label: '我參加的' },
  { key: 'pending', label: '待審核' },
  { key: 'history', label: '歷史紀錄' }
];

export const eventMatchesRecordMode = (event, mode = 'event') => (
  (event?.category === SPORT_CATEGORY) === (mode === 'sport')
);
